// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 18/5/2023
 */


.BrPriv_container__fCzpU {
    margin-top: 2rem;
}

.BrPriv_table__gDO8c {
    height: max-content;
}

.BrPriv_row__xh964 {
    height: 30px;
}

.BrPriv_tCell__ryYI\\+ {
    /* border-bottom: none; */
}

.BrPriv_pagination__l5LyV {
    justify-content: center;
    right: 0;
}

.BrPriv_headingContainer__Q808r {
    display: flex;
    justify-content: space-between;
}

.BrPriv_closeButton__rqmRI {
    padding: 0.2rem;
    border: 1px #5A9BD8 solid;
    color: #5A9BD8;
}

.BrPriv_formItem__BhJb1 {
    margin-top: 1rem;
}

.BrPriv_formLabel__XguoG{
    font-weight: 600;
}

.BrPriv_formInput__UhSD\\+ {
    margin-top: 0.3rem;
}

.BrPriv_submitButton__Q0cNw {
    margin-top: 3rem !important;
    width: 10rem;
}

.BrPriv_buttonContainer__tevVe{
    text-align: center;

}

.BrPriv_validation__KKvKe {
    color: red;
}`, "",{"version":3,"sources":["webpack://./src/Components/BrPrivMapping/BrPriv.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;;AAGF;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,UAAU;AACd","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 18/5/2023\r\n */\r\n\r\n\r\n.container {\r\n    margin-top: 2rem;\r\n}\r\n\r\n.table {\r\n    height: max-content;\r\n}\r\n\r\n.row {\r\n    height: 30px;\r\n}\r\n\r\n.tCell {\r\n    /* border-bottom: none; */\r\n}\r\n\r\n.pagination {\r\n    justify-content: center;\r\n    right: 0;\r\n}\r\n\r\n.headingContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.closeButton {\r\n    padding: 0.2rem;\r\n    border: 1px #5A9BD8 solid;\r\n    color: #5A9BD8;\r\n}\r\n\r\n.formItem {\r\n    margin-top: 1rem;\r\n}\r\n\r\n.formLabel{\r\n    font-weight: 600;\r\n}\r\n\r\n.formInput {\r\n    margin-top: 0.3rem;\r\n}\r\n\r\n.submitButton {\r\n    margin-top: 3rem !important;\r\n    width: 10rem;\r\n}\r\n\r\n.buttonContainer{\r\n    text-align: center;\r\n\r\n}\r\n\r\n.validation {\r\n    color: red;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BrPriv_container__fCzpU`,
	"table": `BrPriv_table__gDO8c`,
	"row": `BrPriv_row__xh964`,
	"tCell": `BrPriv_tCell__ryYI+`,
	"pagination": `BrPriv_pagination__l5LyV`,
	"headingContainer": `BrPriv_headingContainer__Q808r`,
	"closeButton": `BrPriv_closeButton__rqmRI`,
	"formItem": `BrPriv_formItem__BhJb1`,
	"formLabel": `BrPriv_formLabel__XguoG`,
	"formInput": `BrPriv_formInput__UhSD+`,
	"submitButton": `BrPriv_submitButton__Q0cNw`,
	"buttonContainer": `BrPriv_buttonContainer__tevVe`,
	"validation": `BrPriv_validation__KKvKe`
};
export default ___CSS_LOADER_EXPORT___;
